import React, { useContext } from 'react'
import { AuthContext } from '../context/AuthContext'
import DashboardCard from './DashboardCard'

interface Props {
  habitualities: number
  shots?: number
}

export default function HabitualitiesCard({ habitualities, shots }: Props) {
  const { authUser } = useContext(AuthContext)

  return (
    <DashboardCard
      to="/habitualities/create"
      gradient="linear-gradient(135deg, #4a3728 0%, #2e2018 60%, #5c4535 100%)"
      accentColor="#ffc9a3"
      badgeIcon="bi-calendar-event-fill"
      badgeLabel={authUser?.role === 'athlete' ? 'MINHAS HABITUALIDADES' : 'HABITUALIDADES'}
      title="LANÇAMENTOS"
      watermarkIcon="bi-bullseye"
      topRightIcon="bi-list-columns"
      metaLabel="TOTAL DE LANÇAMENTOS"
      value={habitualities || '0'}
      valueSuffix={shots ? `${shots} disparos` : undefined}
    />
  )
}
